import { createReducer } from 'redux-act';
// project files
import * as actions from './actions';

const initialState = {
  isAuthenticated: false,
  accessToken: '',
  user: {
    _id: null,
    name: '',
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    phone: '',
    isPhoneVerified: false,
    roles: [],
    organizationId: null,
    schoolStaff: {
      schoolClasses: [],
      availableCurriculums: [],
    },
  },
};

const authReducer = createReducer(
  {
    [actions.handleAuthSuccess]: (state, payload) => ({
      ...state,
      isAuthenticated: true,
      accessToken: payload.accessToken,
      user: payload.user,
      error: undefined,
    }),
    [actions.handleAuthWithMFA]: (state, payload) => ({
      ...state,
      awaitingMFAUser: payload.mfaUser,
      isMFAEnabled: payload.isMFAEnabled,
    }),
    [actions.handleAuthFailure]: (state, payload) => ({
      ...state,
      error: payload,
    }),
    [actions.signout]: () => ({ ...initialState }),
  },
  initialState
);

export default authReducer;
